import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["grid", "status"]
  static values = { url: String }

  upload(event) {
    const input = event.currentTarget
    if (!input.files.length || !input.reportValidity()) return
    const body = new FormData()
    Array.from(input.files).forEach(file => body.append("photos[images][]", file))
    this.save(this.urlValue, "POST", body, { upload: input })
  }

  metadata(event) {
    event.preventDefault()
    const form = event.currentTarget
    const card = form.closest(".about-photo-column")
    this.save(card.dataset.updateUrl, "PATCH", new FormData(form), { replace: card })
  }

  toggle(event) {
    const button = event.currentTarget
    const card = button.closest(".about-photo-column")
    const body = new FormData()
    body.set("about_photo[enabled]", button.getAttribute("aria-checked") === "true" ? "0" : "1")
    this.save(card.dataset.updateUrl, "PATCH", body, { toggle: button })
  }

  destroy(event) {
    if (!window.confirm("Удалить фотографию безвозвратно?")) return
    const card = event.currentTarget.closest(".about-photo-column")
    this.save(card.dataset.deleteUrl, "DELETE", null, { remove: card })
  }

  async save(url, method, body, options) {
    if (this.saving) return
    this.saving = true
    const controls = this.element.querySelectorAll("button, input[type='submit'], input[type='file']")
    controls.forEach(control => { control.disabled = true })
    this.statusTarget.textContent = options.upload ? "Загружаем фотографии…" : "Сохраняем…"
    this.abort = new AbortController()
    try {
      const response = await fetch(url, {method, body, signal: this.abort.signal,
        headers: {Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""}})
      if (response.redirected || !response.headers.get("content-type")?.includes("application/json")) throw new Error("Не удалось сохранить. Проверьте вход в аккаунт.")
      const result = await response.json()
      if (!response.ok) throw new Error(result.error || "Не удалось сохранить.")
      const top = this.element.getBoundingClientRect().top
      if (options.upload) {
        this.gridTarget.insertAdjacentHTML("beforeend", result.html)
        options.upload.value = ""
        options.upload.dispatchEvent(new Event("change", {bubbles: true}))
      } else if (options.replace) {
        const template = document.createElement("template")
        template.innerHTML = result.html
        const replacement = template.content.firstElementChild
        replacement.querySelector("details").open = options.replace.querySelector("details").open
        options.replace.replaceWith(replacement)
      } else if (options.toggle) {
        options.toggle.classList.toggle("is-enabled", result.enabled)
        options.toggle.setAttribute("aria-checked", String(result.enabled))
      } else if (options.remove) {
        options.remove.remove()
      }
      window.scrollBy(0, this.element.getBoundingClientRect().top - top)
      this.statusTarget.textContent = result.message
    } catch (error) {
      if (error.name !== "AbortError") this.statusTarget.textContent = error.message
    } finally {
      this.saving = false
      controls.forEach(control => { control.disabled = false })
    }
  }

  disconnect() { this.abort?.abort() }
}
